import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { ISharedState } from '@/store/types'
import store from '@/store'
import {
  ConfigAPI,
  RegionInfo,
  SupportedAvatar,
  SupportedGame
} from '@/api/config'

@Module({ dynamic: true, store: store, namespaced: true, name: 'shared' })
export default class SharedModule extends VuexModule implements ISharedState {
  shouldRender: boolean = false

  applicationSupportedAvatars: SupportedAvatar[] = []
  applicationSupportedGames: SupportedGame[] = []
  applicationLocale: string = ''
  applicationRegions: RegionInfo[] = []
  suggestedRegion: string | null = null

  @Mutation
  SET_RENDER_ENABLE(enable: boolean) {
    this.shouldRender = enable
  }

  // Supported Avatars
  @Mutation
  SET_APPLICATION_SUPPORTED_AVATARS(avatars: SupportedAvatar[]) {
    this.applicationSupportedAvatars = avatars
  }

  @Action({ rawError: true })
  setApplicationSupportedAvatars(avatars: SupportedAvatar[]) {
    this.context.commit('SET_APPLICATION_SUPPORTED_AVATARS', avatars)
  }

  // Supported Games
  @Mutation
  SET_APPLICATION_SUPPORTED_GAMES(games: SupportedGame[]) {
    this.applicationSupportedGames = games
  }

  @Action({ rawError: true })
  setApplicationSupportedGames(games: SupportedGame[]) {
    this.context.commit('SET_APPLICATION_SUPPORTED_GAMES', games)
  }

  // Supported Regions
  @Mutation
  SET_APPLICATION_REGIONS(regions: RegionInfo[]) {
    this.applicationRegions = regions
  }

  @Action({ rawError: true })
  setApplicationRegions(regions: RegionInfo[]) {
    this.context.commit('SET_APPLICATION_REGIONS', regions)
  }

  // Suggested Region
  @Mutation
  SET_SUGGESTED_REGION(region: string) {
    this.suggestedRegion = region
  }

  @Action({ rawError: true })
  async updateSuggestedRegion() {
    try {
      const res = await ConfigAPI.getSuggestedRegion()
      this.context.commit(
        'SET_SUGGESTED_REGION',
        res.data.payload ? res.data.payload.code : null
      )
    } catch (err) {
      // ignore error
    }
  }

  // Locale
  @Mutation
  SET_APPLICATION_LOCALE(locale: string) {
    this.applicationLocale = locale
  }

  @Action
  setApplicationLocale(locale: string) {
    this.context.commit('SET_APPLICATION_LOCALE', locale)
  }

  @Action
  rerender() {
    console.log('Rerender triggered.')

    this.context.commit('SET_RENDER_ENABLE', false)

    setTimeout(() => {
      this.context.commit('SET_RENDER_ENABLE', true)
    })
  }

  @Action
  stopRender() {
    this.context.commit('SET_RENDER_ENABLE', false)
  }

  @Action
  enableRender() {
    this.context.commit('SET_RENDER_ENABLE', true)
  }
}
